type Catalogs = Record<string, Record<string, string>>

/**
 * The language to bake, or undefined for an unset SITE_LANG or CI's placeholder. Anything else
 * goes to fundraisingBake, which fails the build for a language with no catalog.
 */
export function bakeLangFor(lang: string | undefined): string | undefined {
  return lang && lang !== 'CI_PLACEHOLDER' ? lang : undefined
}

/**
 * Without a baked catalog (fundraisingBake not registered), merge the package catalogs into
 * vue-i18n under `fundraising.*`. The import is lazy so the catalogs stay out of the entry chunk.
 */
export async function mergeFundraisingFallback(
  baked: unknown,
  merge: (locale: string, message: Record<string, unknown>) => void,
  load: () => Promise<{ fundraisingMessages: Catalogs }> = () => import('fundraising-ui/locales'),
): Promise<void> {
  if (baked) return
  const { fundraisingMessages } = await load()
  for (const [locale, catalog] of Object.entries(fundraisingMessages)) {
    merge(locale, { fundraising: catalog })
  }
}
